import { render, staticRenderFns } from "./OrderListNew.vue?vue&type=template&id=83c10bac&scoped=true"
import script from "./OrderListNew.vue?vue&type=script&lang=js"
export * from "./OrderListNew.vue?vue&type=script&lang=js"
import style0 from "./OrderListNew.vue?vue&type=style&index=0&id=83c10bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c10bac",
  null
  
)

export default component.exports